import {useWatch} from 'react-hook-form'
import {useFieldConfigurationContext} from '../../configuration/useConfigurationContext'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'

export const useIsTestBooked = () => {
  const {control, setValue, formState: {defaultValues}} = useOrderProcessFormContext()
  const testingConfiguration = useFieldConfigurationContext('testing')
  const isTestBooked = useWatch({name: 'isTestBooked', control})
  const defaultIsTestBooked = defaultValues?.isTestBooked

  const setIsTestBooked = (value: boolean) => {
    setValue('isTestBooked', value, {shouldValidate: true})
  }

  return {
    isTestBooked,
    defaultIsTestBooked,
    setIsTestBooked,
    ...testingConfiguration
  }
}
